import { render, staticRenderFns } from "./receiveOrderManage.vue?vue&type=template&id=662ca029&"
import script from "./receiveOrderManage.vue?vue&type=script&lang=js&"
export * from "./receiveOrderManage.vue?vue&type=script&lang=js&"
import style0 from "./receiveOrderManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports